import { eventBatchAPI } from '../services/api';

const PAGE_SIZE = 2000;
const MAX_PAGES = 25;

/** Load every event batch page for admin pickers (trek-scoped, no upcoming filter). */
export async function fetchAllEventBatches(params = {}) {
  const all = [];
  let page = 1;
  while (page <= MAX_PAGES) {
    const res = await eventBatchAPI.list({
      ...params,
      page,
      limit: PAGE_SIZE,
      noCount: 'true'
    });
    const rows = res?.data?.data ?? [];
    all.push(...rows);
    if (rows.length < PAGE_SIZE) break;
    page += 1;
  }
  return all;
}
